import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Switch } from "V2.0/common/switch";
import { Button } from "V2.0/common/button";
import { Tooltip } from "antd";
import { formatTime } from "V2.0/utils";
import {
  PencilIcon,
  TrashIcon,
  DocumentDuplicateIcon,
} from "@heroicons/react/24/outline";

export default PipelineListTable;

interface PipelineListTableProps {
  isViewOnly: boolean;
  pipelines: Array<any>;
  onPipelineClick: (pipelineId: string) => void;
  onPipelineUpdate: (pipelineId: string, data: any) => void;
  onPipelineEdit: (pipelineId: string) => void;
  onPipelineDelete: (pipeline: any) => void;
  onPipelineDuplicate?: (pipeline: any) => void;
}

function PipelineListTable(props: PipelineListTableProps) {
  const {
    pipelines,
    onPipelineClick,
    isViewOnly,
    onPipelineUpdate,
    onPipelineEdit,
    onPipelineDelete,
    onPipelineDuplicate,
  } = props;

  return (
    <div className="h-[70dvh] overflow-scroll">
      <Table dense>
        <TableHead>
          <TableHeader>Pipeline</TableHeader>
          <TableHeader>Created At</TableHeader>
          <TableHeader>Last Updated At</TableHeader>
          <TableHeader>Actions</TableHeader>
        </TableHead>
        <TableBody>
          {pipelines.map((pipeline, idx) => {
            const { _id, name, description, isActive, createdAt, updatedAt } =
              pipeline;
            return (
              <TableRow
                className="hover:cursor-pointer hover:bg-gray-50"
                onClick={() => onPipelineClick(_id)}
                key={idx}
              >
                <TableCell>
                  <div className="flex flex-col gap-y-2">
                    <div className="flex items-start gap-x-2">
                      <p className="font-semibold text-sm">{name}</p>
                      <div>
                        <Switch
                          className="cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(checked) => {
                            onPipelineUpdate(_id, { isActive: checked });
                          }}
                          checked={isActive}
                          color="green"
                          disabled={isViewOnly}
                        />
                      </div>
                    </div>
                    <div className="max-w-[400px]">
                      <Tooltip title={description}>
                        <p className="truncate text-sm text-gray-500">
                          {description}
                        </p>
                      </Tooltip>
                    </div>
                  </div>
                </TableCell>

                <TableCell>
                  <p className="text-sm text-gray-500">
                    {formatTime(createdAt)}
                  </p>
                </TableCell>
                <TableCell>
                  <p className="text-sm text-gray-500">
                    {formatTime(updatedAt)}
                  </p>
                </TableCell>
                <TableCell>
                  {!isViewOnly && (
                    <div className="flex gap-x-2">
                      <Button
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          onPipelineEdit(_id);
                        }}
                      >
                        <PencilIcon className="size-5" />
                      </Button>
                      {onPipelineDuplicate && (
                        <Button
                          outline
                          onClick={(e) => {
                            e.stopPropagation();
                            onPipelineDuplicate(pipeline);
                          }}
                        >
                          <DocumentDuplicateIcon className="size-5" />
                        </Button>
                      )}
                      <Button
                        outline
                        onClick={(e) => {
                          e.stopPropagation();
                          onPipelineDelete(pipeline);
                        }}
                      >
                        <TrashIcon />
                      </Button>
                    </div>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
